import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { EConsultationReferralResponse } from 'app/integration/document/services/digilugu-referral';

@Injectable()
export class EConsultationReferralService {
  constructor(private http: HttpClient) {}

  protected baseUrl = `${environment.estnhsApi}/digilugu/e-consultation-referrals`;

  public sendResponse(resp: EConsultationReferralResponse): Observable<any> {
    return this.http.post(`${this.baseUrl}/response`, resp);
  }
}
